import React from 'react';
import { Card, Steps, Alert } from 'antd';

const statusByCode = (code) => {
	switch (code) {
		case 'I':
			return { code: 'I', step: 1, label: 'Incomplete', status: 'error' };
		case 'R':
			return { code: 'R', step: 1, label: 'Processing' };
		case 'A':
			return { code: 'A', step: 2, label: 'Approved', status: 'finish' };
		case 'W':
			return { code: 'W', step: 0, label: 'Waived', status: 'finish' };
		default:
			return { code: null, step: 0, label: 'Unreceived', status: 'error' };
	}
};

export default class StandardSteps extends React.Component {
	render() {
		const status = statusByCode(this.props.code);
		return (
			<div>
				{status.code === 'W' &&
					<Alert showIcon type="success" icon="check-circle-o" message="Waived" />
				}
				{status.code !== 'W' &&
					<Card>
						<Steps size={this.props.size || 'default'} current={status.step} status={status.status}>
							<Steps.Step title={(status.step === 0)? status.label: 'Received'} />
							<Steps.Step title={(status.step === 1)? status.label: 'Processing'} />
							<Steps.Step title={(status.step === 2)? status.label: 'Approved'} />
						</Steps>
					</Card>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/StandardSteps/index.jsx